import { UserCheck, ShieldCheck, Truck, Route } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

const icons = [UserCheck, ShieldCheck, Truck, Route];

export function TrustBar() {
  const { t } = useLang();
  return (
    <section id="trust" data-testid="trust-section" className="relative border-b border-edge bg-asphalt">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {t.trust.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={item.t} delay={i * 0.08} className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md border border-edge bg-carbon text-amber">
                  <Icon className="h-5 w-5" strokeWidth={2} />
                </span>
                <div>
                  <h3 className="font-display text-base font-bold text-ice">{item.t}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-steel">{item.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
